import {HttpModelConverter} from "../../../../../../../core/converter/httpModel.converter";
import {TreatmentJourneyStepFeedbackModel} from "./treatmentJourneyStepFeedback.model";
import {Injectable} from "@angular/core";
import {TreatmentJourneyStepReminderModel} from "./treatmentJourneyStepReminder.model";

@Injectable({
    providedIn: 'root'
})
export class TreatmentJourneyStepReminderConverter extends HttpModelConverter<TreatmentJourneyStepReminderModel> {
    protected createInstance(): TreatmentJourneyStepReminderModel {
        return new TreatmentJourneyStepReminderModel();
    }

    protected enrichObject(result: TreatmentJourneyStepReminderModel, src: TreatmentJourneyStepReminderModel) {
    }

}